/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const NonImpairing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Non-impairing"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#DADADA"
        d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M17 16.167H7V14.5h10zM8.667 7.833a1.667 1.667 0 1 1 0 3.334 1.667 1.667 0 0 1 0-3.334m6.666 0a1.667 1.667 0 1 1 0 3.334 1.667 1.667 0 0 1 0-3.334"
      />
    </g>
  </svg>
);

export const NonImpairingIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'non-impairing-icon'}
      icon={NonImpairing}
      {...props}
      size={size}
    />
  );
};
